import { RecommendedScale } from './RecommendedScale';

export default RecommendedScale;
